import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { type ReactNode, useState } from 'react';
type CaretPlaceholderProps = {
  children: ReactNode;
  className: string;
  overlayClassName: string;
  text: string;
};
const CaretPlaceholder = t0 => {
  const $ = _c(11);
  const {
    children,
    className,
    overlayClassName,
    text
  } = t0;
  const [showing, setShowing] = useState(false);
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowing(false);
    t2 = event => setShowing(!readText(event.target));
    t3 = event_0 => setShowing(!readText(event_0.target as HTMLElement));
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== overlayClassName || $[4] !== showing || $[5] !== text) {
    t4 = showing && <span aria-hidden={true} className={cx("pointer-events-none absolute inset-0", overlayClassName)}>{text}</span>;
    $[3] = overlayClassName;
    $[4] = showing;
    $[5] = text;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== className || $[9] !== t4) {
    t5 = <div className={className} onBlur={t1} onFocus={t2} onInput={t3}>{t4}{children}</div>;
    $[7] = children;
    $[8] = className;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
const readText = (element: HTMLElement) => {
  return element.textContent ?? '';
};
export default CaretPlaceholder;